import App from "./App";
import ReactDom from "react-dom";
import "./i18n";
import CustomTheme from "./Theme";
import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
ReactDom.render(
  <ThemeProvider theme={CustomTheme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById("root")
);
